import React, { useState } from "react"
import { Chip, IconButton, Collapse, Typography, Stack, Tooltip, Box } from '@mui/material'
import {
    ExpandLess, ExpandMore, Clear as ClearIcon,
} from '@mui/icons-material';
import { getShortText, dateTimeFormater } from '../../../services/functions';
import theme, { textClasses } from "../../../static/styles/theme";

const CustomChip = ({ data = [], makeDisabled = false, handleDelete, readLabelKey = "$self",chipVisibleCount = 5 , chipVisibleLessMore= false, textLengthSize = 20, chipHeight="32px", textFontSize = "0.8rem", chipDataWrap="wrap"}) => {
    const [expand, setExpand] = useState(false);
    let renderChip = (labelObj = "", index = 0) => {
        let name = labelObj;
        if (readLabelKey) {
            if (readLabelKey === "$self") {
                name = labelObj;
            } else {
                name = labelObj[readLabelKey];
            }
        }

        // Format assigned_at if it exists
        // const assignedDate =
        //     typeof labelObj === "object" && labelObj?.assigned_at
        //         ? dateTimeFormater(labelObj?.assigned_at)
        //         : null;

        return (
            <Chip
                label={
                    // <Tooltip title={assignedDate || name} placement="top">
                    <Tooltip title={`${name}${labelObj?.run_at ? `(${dateTimeFormater(labelObj?.run_at)})` : ""}`} placement="top">
                        <Box display="flex" alignItems="center" gap={0.5}>
                            {typeof labelObj === "object" && labelObj?.icon && (
                                <span
                                    className="material-symbols-outlined"
                                    style={{
                                        fontSize: "14px",
                                        color: labelObj?.color || "#fff",            // Icon font color
                                        backgroundColor: labelObj?.bgColor || "#000", // Icon background
                                        padding: "2px",
                                        borderRadius: "6px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    {labelObj.icon}
                                </span>
                            )}
                            <Typography
                                sx={{
                                    fontSize: textFontSize,
                                    overflow: "hidden",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                }}
                            >
                                {getShortText(name, textLengthSize)}
                            </Typography>
                        </Box>
                    </Tooltip>
                }
                key={index}
                sx={{
                    m: data?.length == 1 ? 0 : 0.5,
                    backgroundColor:
                        (typeof labelObj === "object" && labelObj?.bgColor) || theme.themeLightPrimary,
                    color:
                        (typeof labelObj === "object" && labelObj?.color) || theme.themeOrange,
                    border: `1px solid ${(typeof labelObj === "object" && labelObj?.color) || theme.themeOrange
                        }`,
                    height: chipHeight,
                }}
                {...(handleDelete
                    ? {
                        onDelete: () => handleDelete(index, name),
                        deleteIcon: (
                            <IconButton
                                disabled={makeDisabled ? !data || data.length <= 1 : false}
                            >
                                <ClearIcon sx={{ color: theme.themeOrange }} />
                            </IconButton>
                        ),
                    }
                    : {})}
            />
        );
    };


    return (
        <Box>
            <Stack
                direction="row"
                flexWrap={chipDataWrap}
                justifyContent="start"
                alignItems="start"
                data-testid="data-jobtype"

            >
                {
                    data?.length && data.slice(0, chipVisibleCount).map((dl, index) => renderChip(dl || "", index))
                }

                {
                    data?.length > chipVisibleCount &&
                    <>
                        {!expand &&
                            <Typography
                                sx={{ ...textClasses.normalText, textAlign: "center", color: theme.themeOrange, mt: 1 }}
                            >
                                {chipVisibleLessMore ? (
                                    <span
                                        style={{ textDecoration: "underline", cursor: "pointer" }}
                                        onClick={() => setExpand(true)}
                                    >
                                        +{data?.length - chipVisibleCount} More
                                    </span>
                                ) : (
                                    <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setExpand(true)}>
                                        View All
                                        <ExpandMore />
                                    </span>
                                )}                            </Typography>
                        }
                        <Collapse in={expand} timeout="auto" unmountOnExit>
                            {data.slice(chipVisibleCount).map((dl, index) => renderChip(dl || "", chipVisibleCount + index))}
                        </Collapse>
                        {expand &&
                            <Typography
                                sx={{ ...textClasses.normalText, textAlign: "center", color: theme.themeOrange, mt: 1 }}
                            >
                               {chipVisibleLessMore ? "Less" : "View Less"}<ExpandLess onClick={() => setExpand(false)} style={{ cursor: "pointer" }} />
                            </Typography>
                        }
                    </>
                }
            </Stack>
        </Box>
    )
}

export default CustomChip
